import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEclipseideComponent } from './simple-icons-eclipseide.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEclipseideComponent ],
    exports:      [ SimpleIconsEclipseideComponent ],
    bootstrap:    []
})
export class SimpleIconsEclipseideModule {}
